export function getLanguageCode()
{
    return document.querySelector('html').getAttribute('lang');
}

function createElementFromHTML(htmlString)
{
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes.
    return div.firstChild;
}

function getFeedbackMessage(classList, iconClassList, message, title = '', useTextKeys = false)
{
    let feedbackId = message + title;

    message = useTextKeys ? getTranslation(message) : message;
    title = useTextKeys ? getTranslation(title) : title;

    let content =
		'<p>'
			+ message
		+ '</p>';

    if (title !== '')
    {
        content =
			'<h2>'
				+ title
			+ '</h2>'
			+ '<p>'
				+ message
			+ '</p>';
    }

    let el = createElementFromHTML(
        '<div class="feedback js-feedback">'
			+ '<i class="fa-regular ' + iconClassList.join(' ') + '"></i>'
			+ content
			+ '<a href="#" class="close">'
				+ '<i class="fa-regular fa-times"></i>'
			+ '</a>'
		+ '</div>'
    );

    el.classList.add(...classList);

    if (useTextKeys)
    {
        el.dataset.feedbackTextKeys = feedbackId;
    }

    return el;
}

function displayFeedbackMessage(feedbackEl)
{
    let body = document.querySelector('body');

    body.append(feedbackEl);
    $('body').trigger('feedback-added');
}

function feedbackMessageExists(messageTextKey, titleTextKey)
{
    let value = messageTextKey + titleTextKey;
    let feedbacks = document.querySelector('[data-feedback-text-keys="' + value + '"]');

    return feedbacks !== null;
}

export function displaySuccessFeedbackMessage(message, title = '', useTextKeys = false, allowDuplicates = true)
{
    if (useTextKeys && feedbackMessageExists(message, title) && !allowDuplicates)
    {
        return;
    }

    let feedbackEl = getFeedbackMessage(['success', 'js-feedback-autohide'], ['fa-check'], message, title, useTextKeys);

    displayFeedbackMessage(feedbackEl);

    return feedbackEl;
}

export function displayInfoFeedbackMessage(message, title = '', useTextKeys = false, allowDuplicates = false)
{
    if ((useTextKeys && feedbackMessageExists(message, title)) && !allowDuplicates)
    {
        return;
    }

    let feedbackEl = getFeedbackMessage(['info'], ['fa-info-circle'], message, title, useTextKeys);

    displayFeedbackMessage(feedbackEl);

    return feedbackEl;
}

export function displayErrorFeedbackMessage(message, title = '', useTextKeys = false, allowDuplicates = false)
{
    if ((useTextKeys && feedbackMessageExists(message, title)) && !allowDuplicates)
    {
        return;
    }

    let feedbackEl = getFeedbackMessage(['error'], ['fa-exclamation-circle'], message, title, useTextKeys);

    displayFeedbackMessage(feedbackEl);

    return feedbackEl;
}

export function getTranslation(key)
{
    let element = document.querySelector('meta[name="' + key + '"]');

    if (element !== null && element.hasAttribute('content'))
    {
        return element.getAttribute('content');
    }
    else
    {
        console.warn('No translation key found for: ' + key);
    }

    return '';
}

export function fetchFormValues(formElement, ignoreHidden = false)
{
    var formElements = formElement.elements;
    var values = {};

    // .elements also gives us fieldsets, buttons etc. we dont need
    var filteredElements = [...formElements].filter(
        element =>
            element.matches('input')
			|| element.matches('textarea')
			|| element.matches('select')
    );

    filteredElements.forEach(function(element)
    {
        if (element.matches('[type=hidden]') && ignoreHidden)
        {
            return;
        }

        var name = element.getAttribute('name');
        var { value } = element;

        if (!name)
        {
            // works like `continue` in a forEach loop
            return;
        }

        let index = null;

        // Handle input names with array notation and assign `name` and `index` variable to create nested objects later
        if (name.indexOf('[') !== -1)
        {
            let matchIndex = name.match(/\[([^\]]+)]/);

            if (matchIndex)
            {
                [, index] = matchIndex;
            }

            let matchName = name.match(/^[^[]+/);

            if (matchName)
            {
                [name] = matchName;
            }
        }

        /**
		 * For radio buttons and checkboxes we use the value only if it is checked.
		 * Otherwise we unset the value variable. The values for inputs with same names are merged later.
		 */
        if (element.matches('[type=radio]') || element.matches('[type=checkbox]'))
        {
            let checked = !!element.matches(':checked');

            if (!checked)
            {
                value = '';
            }
        }

        if (element.matches('[type=file]'))
        {
            value = element.files;
        }

        let newValue = value;

        // Create nested objects, if index is set
        if (index)
        {
            if (!values[name])
            {
                values[name] = {};
            }

            if (!values[name][index])
            {
                values[name][index] = '';
            }

            if (values[name][index] !== '')
            {
                newValue = values[name][index];

                if (value !== '')
                {
                    newValue = values[name][index] + ',' + value;
                }
            }

            values[name][index] = newValue;
        }
        else
        {
            if (!values[name])
            {
                values[name] = '';
            }

            if (values[name] !== '')
            {
                newValue = values[name];

                if (value !== '')
                {
                    newValue = values[name] + ',' + value;
                }
            }

            values[name] = newValue;
        }
    });

    return values;
}

export function removeValue(arr, value)
{
    return arr.filter(function(ele)
    {
        return ele !== value;
    });
}

/**
 * Convert a template string into HTML DOM nodes
 * @param  {String} str The template string
 * @return {Node}       The template HTML
 */
export function stringToHTML(str)
{
    var parser = new DOMParser();
    var doc = parser.parseFromString(str, 'text/html');
    return doc.body.firstChild;
}

/**
 * Decodes HTML entities in a string (e.g. &euro; -> €).
 *
 * @param {string} str  The HTML-encoded string to decode.
 * @returns {string}    The decoded text string.
 */
export function decodeHTMLEntities(str)
{
    const textarea = document.createElement('textarea');
    textarea.innerHTML = str;
    return textarea.value;
}

/**
 * Converts an array into a URL query string with a given prefix.
 * @param {Array} array - The array of values to be converted.
 * @param {string} prefix - The prefix to be added before each value.
 * @returns {string} The URL query string with the prefix and brackets.
 */
export function arrayToPrefixedUrlQuery(array, prefix)
{
    return array.map(x => prefix + '[]=' + x).join('&');
}

/**
 * Debounce function to prevent multiple calls of a function
 * @param {function} func - The function to be called
 * @param {number} timeout - The timeout in ms
 * @returns {function} The debounced function
 */
export function debounce(func, timeout = 500)
{
    let timer;

    return (...args) =>
    {
        clearTimeout(timer);
        timer = setTimeout(() =>
        {
            func.apply(this, args);
        }, timeout);
    };
}
